import { render, staticRenderFns } from "./bulk-upload.vue?vue&type=template&id=20421e16&"
import script from "./bulk-upload.vue?vue&type=script&lang=js&"
export * from "./bulk-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20421e16')) {
      api.createRecord('20421e16', component.options)
    } else {
      api.reload('20421e16', component.options)
    }
    module.hot.accept("./bulk-upload.vue?vue&type=template&id=20421e16&", function () {
      api.rerender('20421e16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/receipt/bulk-upload.vue"
export default component.exports